import * as React from "react";

function Calendar(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 21" fill="none" {...props}>
      <path
        d="M15 2.5h4a1 1 0 011 1v16a1 1 0 01-1 1H1a1 1 0 01-1-1v-16a1 1 0 011-1h4v-2h2v2h6v-2h2v2zm3 8H2v8h16v-8zm-5-6H7v2H5v-2H2v4h16v-4h-3v2h-2v-2zm-9 8h2v2H4v-2zm5 0h2v2H9v-2zm5 0h2v2h-2v-2z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoCalendar = React.memo(Calendar);
export default MemoCalendar;
